import {
  BalanceSignupStatusContextFields,
  BalanceSignupStatusFieldsResponseRaw,
} from 'src/components/selfService/common/Balance/balanceSignup.types';
import { camelizeResponseData } from 'src/utilities/http-data-casing';

const EMPTY_BALANCE_SIGNUP_STATUS_CONTEXT: BalanceSignupStatusContextFields = {
  validationStatus: null,
  externalId: null,
  onboardingId: null,
  onboardingUrl: null,
  creditLimit: null,
};

export function transformBalanceSignupStatusFields(
  rawBalanceFields?: BalanceSignupStatusFieldsResponseRaw
): BalanceSignupStatusContextFields {
  if (!rawBalanceFields) {
    return EMPTY_BALANCE_SIGNUP_STATUS_CONTEXT;
  }

  const {
    balanceValidationStatus,
    balanceExternalId,
    balanceOnboardingId,
    balanceOnboardingUrl,
    balanceCreditLimit,
  } = camelizeResponseData(rawBalanceFields);

  return {
    validationStatus: balanceValidationStatus,
    externalId: balanceExternalId,
    onboardingId: balanceOnboardingId,
    onboardingUrl: balanceOnboardingUrl,
    creditLimit: balanceCreditLimit,
  };
}
